import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ChatService } from '../../../services/chat.service';

@Component({
  selector: 'app-chat-footer',
  templateUrl: './chat-footer.component.html',
  styleUrls: ['./chat-footer.component.scss']
})
export class ChatFooterComponent implements OnInit {
  message = new FormControl('', [Validators.required]);

  constructor(private chatService: ChatService) { }

  ngOnInit(): void {
  }

  send() {
    if (this.message.invalid) {
      this.message.updateValueAndValidity();
      return;
    }
    this.chatService.sendMessage(this.message.value).subscribe(x => {
      this.message.setValue('');
      this.chatService.chatUpdate();
    }, error => {
        console.log(error);
    })
  }

  attach() {
    console.log('Прикрепить файлы');
  }
}
